<template>
	<div class="wrapper">
		<div class="loading-dots" v-if="!oauthData && !error">
			<img src="/images/pronto/3-dot-loader.gif" />
		</div>
		<div class="error-container" v-if="error">
			{{ error }}
		</div>
		<div class="content" v-if="oauthData && !error">
			<h3>
				<span class="green">{{ client.name }}</span> wants to access your Pronto
				account
			</h3>
			<div class="user-info">
				<img
					data-v-b91a6428=""
					:src="user.profilepicurl"
					alt="Profile"
					class="avatar"
				/>
				<h4>{{ user.firstname }} {{ user.lastname }}</h4>
				<div class="org">
					Signed into <span class="green">{{ organization }}</span>
				</div>
			</div>
			<TextDivider
				:text="`This will allow ${client.name} to`"
				:textStyle="{
					color: '#9498a3',
					fontSize: '12px',
					fontFamily: 'Avenir-Light',
				}"
			/>
			<div class="scope" v-for="scope in scopes" :key="scope.id">
				{{ scope.description }}
			</div>
			<div class="actions">
				<button class="pronto-blue-pill-btn" @click="accept">
					Allow and Continue
				</button>
				<button class="link-btn" @click="deny">
					Cancel
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { get, post, del } from '../helpers/api'
import { showError } from '../helpers/utils'
import { TextDivider } from '../components/common'

export default {
	name: 'OAuth',
	components: { TextDivider },
	data() {
		return {
			oauthData: null,
			client: {},
			user: {},
			organization: '',
			scopes: [],
			error: null,
		}
	},
	methods: {
		async initiate() {
			try {
				const { data } = await get(
					`/api/v1/oauth.initiate${window.location.search}`
				)
				const {
					auth_token,
					client,
					user,
					organization,
					scopes,
					state,
					location: redirect,
					error,
					message: errorMessage,
				} = data
				if (error) {
					// Show generic message
					// Possible scenarios:
					// 1) Invalid client id
					// 2) Invalid redirect_uri
					// 3) Random API failure
					return (this.error = errorMessage)
				}
				if (redirect) {
					// Possible scenarios:
					// 1) A token already exists for this user/client, so auto-approving
					// 2) Some error occurred, so redirecting to display error
					return (window.location = redirect)
				}
				this.oauthData = { auth_token, client_id: client.id, state }
				Object.assign(this, { client, user, organization, scopes })
			} catch (e) {
				console.error('CANNOT INITIATE', e)
				this.error = 'An unknown error occurred. Please try again.'
			}
		},
		async accept() {
			const payload = this.oauthData
			this.oauthData = null
			try {
				const { data } = await post('/api/v1/oauth.accept', payload)
				// user will be navigated back to their originating client app
				window.location = data.location
			} catch (e) {
				this.oauthData = payload
				console.error('CANNOT ACCEPT', e)
				this.error = 'An unknown error occurred. Please try again.'
			}
		},
		async deny() {
			const payload = this.oauthData
			this.oauthData = null
			try {
				const { data } = await del('/api/v1/oauth.deny', payload)
				// user will be navigated back to their originating client app
				window.location = data.location
			} catch (e) {
				this.oauthData = payload
				console.error('CANNOT DENY', e)
				this.error = 'An unknown error occurred. Please try again.'
			}
		},
	},
	mounted() {
		this.initiate()
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

$red-alpha: rgba(224, 100, 119, 0.1);

.wrapper {
	padding: 40px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	background: #fafafa;
	height: 100vh;
	overflow: auto;
}
.content {
	background: white;
	border-radius: 15px;
	padding: 40px 40px 8px 40px;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	max-width: 440px;
	margin: 40px;
	h3,
	h4,
	.user-info,
	.org {
		width: 100%;
		text-align: center;
		margin: 0 0 16px 0;
	}
	.org {
		font-family: Avenir-Light;
	}
}
.user-info {
	display: flex;
	align-items: center;
	flex-direction: column;
}
.actions {
	display: flex;
	align-items: center;
	flex-direction: column;
}
.avatar {
	width: 76px;
	border-radius: 50%;
	margin: 24px 0 16px 0;
	display: block;
}
.green {
	color: var(--teal-300);
}
.scope {
	width: 100%;
	padding: 24px 0;
	font-size: 14px;
	color: #9498a3;
	border-bottom: 1px solid #e2e4e6;
	font-family: Avenir-Light;
	text-align: center;
}
.actions {
	margin-top: 24px;
	.pronto-blue-pill-btn {
		padding: 8px 16px;
		width: 276px;
		border: 0;
		font-family: Avenir-Light;
	}
	.link-btn {
		font-size: 14px;
		font-family: Avenir-Light;
		color: #9498a3;
		border: 0;
		outline: 0;
		padding: 16px;
	}
}
.error-container {
	margin: 100px;
	padding: 60px;
	border-radius: 24px;
	background: $red-alpha;
	color: var(--red-200);
	border: 2px solid var(--red-200);
	max-width: 400px;
}
</style>
